/**
 * Utility functions for certification services
 */

/**
 * Safely format date to ISO string or return a default value
 * @param date Date to format
 * @param defaultValue Default value to return if date is invalid
 * @returns Formatted date string
 */
export function safeFormatDate(date: Date | string | null | undefined, defaultValue: string = ''): string {
  if (!date) return defaultValue;
  
  try {
    if (typeof date === 'string') {
      // If it's already a string, check if it's a valid ISO date
      const parsedDate = new Date(date);
      return !isNaN(parsedDate.getTime()) ? date : defaultValue;
    }
    
    // Otherwise format the date
    return date.toISOString();
  } catch (error) {
    console.error('Error formatting date:', error);
    return defaultValue;
  }
}

/**
 * Sanitizes text to prevent XSS attacks when generating certificates
 * @param text Text to sanitize
 * @returns Sanitized text
 */
export function sanitizeText(text: string): string {
  if (!text) return '';
  
  // Simple sanitization - replace HTML special chars with entities
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

/**
 * Generate certificate HTML from template
 * This is a placeholder for the actual implementation
 */
export function generateCertificateHTML(templateId: string, data: Record<string, string>): string {
  return `<div class="certificate">Certificate for ${sanitizeText(data.studentName || 'Student')}</div>`;
}
